








































import {
  createComponent,
  inject,
  computed,
  onMounted,
  SetupContext
} from "@vue/composition-api";

import SupportKey from "@/components/support-key";
import MemberKey from "@/components/member-key";
import _ from "lodash";
import router from "@/router";

export default createComponent({
  setup(props: {}, context: SetupContext) {
    const supportStore = inject(SupportKey);
    if (!supportStore) {
      throw new Error(`${SupportKey} is not provided`);
    }

    const memberStore = inject(MemberKey);
    if (!memberStore) {
      throw new Error(`${MemberKey} is not provided`);
    }

    const member = computed(() => memberStore.member);
    const inquiryReceiptNumber = computed(
      () => supportStore.inquiryReceiptNumber
    );

    const globalStore = context.root.$store;

    const moveTop = () => {
      // @ts-ignore
      if (globalStore.isMobileWebView) {
        // @ts-ignore
        window.flutter_inappwebview.callHandler("closeWebView", "");
      } else {
        context.root.$router.push({
        name: "MemberHome"
      });
      }

    };

    onMounted(async () => {
      if (!("card_number" in member.value)) {
        context.root.$router.push({ name: "MemberFaqInquiry" });
      }
    });

    return {
      inquiryReceiptNumber,
      moveTop
    };
  },
  components: {}
});
